import useVuelidate from '@vuelidate/core';
import { mapActions, mapState } from 'vuex';

import { SNACKBAR_TYPES, VERIFY_MAIL_TYPES } from '@/utils/constants';
import {
  email,
  required,
} from '@/utils/validators';

export default {
  name: 'SendVerifyEmail',
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      btnText: '重發驗證信',
      email: '',
      title: '驗證',
    };
  },
  computed: {
    ...mapState('user', {
      sendingForgetPwdLink: ({ sendingForgetPwdLink }) => sendingForgetPwdLink,
      resending: ({ resending }) => resending,
    }),
    isTypeResetPwd() {
      const type = this.$route?.params?.type;
      return type === VERIFY_MAIL_TYPES.RESET_PASSWORD;
    },
    loading() {
      return this.isTypeResetPwd ? this.sendingForgetPwdLink : this.resending;
    },
  },
  created() {
    if (this.isTypeResetPwd) {
      this.title = '重設密碼';
      this.btnText = '發送重設密碼連結';
    }
  },
  methods: {
    ...mapActions('user', {
      resendEmail: 'RESEND_VERIFY_EMAIL',
      sendForgetPwdLink: 'SEND_FORGET_PASSWORD_LINK',
    }),
    async resend() {
      const valid = await this.v$.$validate();
      if (!valid) return;

      const title = this.isTypeResetPwd ? '重設密碼連結' : '帳號驗證連結';
      try {
        if (this.isTypeResetPwd) {
          await this.sendForgetPwdLink(this.email);
        } else {
          await this.resendEmail(this.email);
        }
        this.$snackbar({ type: SNACKBAR_TYPES.SUCCESS, title: `${title}已發送`, msg: '請檢查您的電子信箱。' });
        this.$router.replace('/login');
      } catch (error) {
        const { message } = error;
        const errorMessage = message ? `（錯誤：${message}）` : '';

        this.$snackbar({
          type: SNACKBAR_TYPES.ERROR,
          title: `${title}發送失敗`,
          msg: `請確認資料無誤並稍後再試一次。${errorMessage}`,
        });
      }
    },
  },
  validations() {
    return {
      email: { required: required('電子郵件'), email },
    };
  },
};
